export default "__VITE_PUBLIC_ASSET__1da66c67__"